/** API of the translations referential (port of TranslationService). */
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import { api } from '@/shared/api/client';

export const translationSchema = z.object({
  id: z.string(),
  section: z.string().nullish(),
  key: z.string().nullish(),
  value: z.string().nullish(),
  language: z.string().nullish(),
});

export type Translation = z.infer<typeof translationSchema>;

/** Raw rows of a language (`includeID=true`), not the grouped bundle used by i18n. */
export const translationsQueryOptions = (locale: string) =>
  queryOptions({
    queryKey: ['translations', 'raw', locale] as const,
    queryFn: () =>
      api.get<Translation[]>(`config/translations/${locale}`, {
        query: { includeID: 'true' },
        schema: z.array(translationSchema),
      }),
    enabled: !!locale,
    retry: false,
  });

/** Payload of the creation call: one row of a language. */
export interface TranslationInput {
  section: string;
  key: string;
  value: string;
  language: string;
}

export const createTranslation = (data: TranslationInput) =>
  api.post<unknown>('config/translations', data);

/** Rows are edited inline and sent back as fetched (`includeID=true`). */
export const updateTranslation = (data: Translation) =>
  api.put<unknown>('config/translations', data);
